import { axiosRequest } from '@/util/axios-request'
const method = 'get'
const listUrl = '/web/staff/list'
const viewUrl = '/web/staff/view'
const addUrl = '/web/staff/create'
const updateUrl = '/web/staff/edit'
const sysInfoUrl = '/web/staff/sysInfo'
const searchStaffUrl = '/web/staff/searchStaff'
const getCallTypeUrl = '/web/staff/getCallTypes'
const getSexUrl = '/web/staff/getSex'

// 员工列表
export const listUrlFn = params => axiosRequest({ url: listUrl, method, params })

// 员工详情
export const viewUrlFn = params => axiosRequest({ url: viewUrl, method, params })

// 新增
export const addFn = data => axiosRequest({ url: addUrl, data })

// 更新
export const updateFn = data => axiosRequest({ url: updateUrl, data })

// 员工基础信息
export const sysInfoFn = () => axiosRequest({ url: sysInfoUrl, method })

// 员工搜索（姓名和手机号）
export const searchStaffFn = params => axiosRequest({ url: searchStaffUrl, method, params })

// 获取称谓
export const getCallTypeUrlMethod = params => axiosRequest({ url: getCallTypeUrl, method, params })

// 获取性别
export const getSexUrlMethod = params => axiosRequest({ url: getSexUrl, method, params })

// 需要导出的字段
export const getExportColumns = params => axiosRequest({ url: '/web/staff/getExportColumns', method, params })

// 导出
export const exportData = params => axiosRequest({ url: '/web/staff/export', method, params })

// 转正管理列表
export const getRegularLists = params => axiosRequest({ url: '/web/staff_regular/lists', method, params })

// 试用期管理枚举项
export const getRegularInfo = params => axiosRequest({ url: '/web/staff_regular/init', method, params })

// 转正管理列表导出
export const regularExport = params => axiosRequest({ url: '/web/staff_regular/export', method, params })

// 办理转正
export const addStaffRegular = params => axiosRequest({ url: '/web/staff_regular/addStaffRegular', method, params })

// 编辑转正信息
export const editStaffRegular = params => axiosRequest({ url: '/web/staff_regular/editStaffRegular', method, params })

// 编辑转正信息
export const cancelStaffRegular = params => axiosRequest({ url: '/web/staff_regular/cancelStaffRegular', method, params })

// 获取国家
export const getCountries = params => axiosRequest({ url: '/web/address/countries', method, params })